var timespan = {
    bindings : {
        from : '@',
        to : '@'
    },
    controller : function TimespanCtrl () {
        function link () {
            ctrl.startMoment = moment(ctrl.from, 'YYYY-MM-DD HH:mm:ss');
            ctrl.endMoment = moment(ctrl.to, 'YYYY-MM-DD HH:mm:ss'); // might be invalid
            ctrl.span = ctrl.startMoment.format('Do MMM YYYY, HH:mm');
            if (ctrl.to) {
                if (ctrl.startMoment.dayOfYear() == ctrl.endMoment.dayOfYear()) {
                    ctrl.span += ' - ' + ctrl.endMoment.format('HH:mm');
                }
                else {
                    ctrl.span += ' - ' + ctrl.endMoment.format('Do MMM YYYY, HH:mm');
                }
            }
        }

        var ctrl = this;
        this.$postLink = link;
    },
    template : '<span ng-bind="$ctrl.span"></span>'
}